export default function generateUpdateMessage({
  message,
  statusesList,
  username,
  t,
  usersList,
}) {
  const messageObject = JSON.parse(message);

  const getStatusName = (statusVal) => {
    let status = statusesList.find((s) => Number(s.statusId) === Number(statusVal));

    if (!status) {
      status = statusesList.find(
        (s) => s.name?.toUpperCase() === String(statusVal).toUpperCase()
      );
    }

    return status ? t(`status.${status.name}`) : statusVal || '';
  };
  const attribute = (actionText) => (username ? `${username} ${actionText}` : actionText);

  const updatesList = Object.keys(messageObject).map((key) => {
    const entry = messageObject[key];
    let prevVal = entry.previousValue;
    let newVal = entry.newValue;
    switch (key) {
      case 'Status':
        prevVal = getStatusName(prevVal);
        newVal = getStatusName(newVal);
        if (!prevVal || !newVal) return undefined;
        break;

      case 'Priority':
        prevVal = t(`priority.${prevVal}`);
        newVal = t(`priority.${newVal}`);
        break;

      case 'Description':
        return attribute(t('pages.ticketDetails.ticketUpdateDescriptionLog'));

      case 'Creation':
        return attribute(t('pages.ticketDetails.ticketCreatedLog'));

      case 'Tagged':
        return attribute(
          t('pages.ticketDetails.userTaggedLog', {
            username2: entry.userName,
            permission: entry.write
              ? t('pages.ticketDetails.readAndModify')
              : t('pages.ticketDetails.onlyRead'),
          })
        );

      case 'Untagged':
        return attribute(
          t('pages.ticketDetails.userUntaggedLog', {
            username2: entry.userName,
          })
        );

      case 'updatePerm':
        return attribute(
          t('pages.ticketDetails.updatePermLog', {
            username2: entry.userName,
            permission: entry.write
              ? t('pages.ticketDetails.readAndModify')
              : t('pages.ticketDetails.onlyRead'),
          })
        );

      case 'AssignedTo': {
        const prevUser =
          prevVal === '-1' || prevVal === -1
            ? 'None'
            : usersList.find((user) => user.id === parseInt(prevVal, 10))?.username ||
              prevVal;

        const newUser =
          newVal === '-1' || newVal === -1
            ? 'None'
            : usersList.find((user) => user.id === parseInt(newVal, 10))?.username ||
              newVal;

        return attribute(
          t('pages.ticketDetails.ticketReassignedLog', {
            previousAgent: prevUser,
            newAgent: newUser,
          })
        );
      }

      case 'Tags':
        return attribute(t('pages.ticketDetails.ticketTagsUpdatedLog'));

      default:
        break;
    }

    return attribute(
      t('pages.ticketDetails.ticketUpdateLog', {
        attribute: t(`attributes.${key.toLowerCase()}`),
        prevValue: prevVal,
        newValue: newVal,
      })
    );
  });

  return updatesList.filter(Boolean);
}
